// extracted by mini-css-extract-plugin
module.exports = {"c-video-wrapper":"YouTubeVideo_c-video-wrapper__eMpZy"};